import NotePage from "./views/NotePage";

const routes = [
  {
    path: "/note/",
    name: "note",
    component: NotePage,
    props: route => ({
      matterUid: route.query.matterUid,
      noteUid: route.query.noteUid
    })
  }
];

export default routes;
